<template>
  <div class="user">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="所属通道">
        <el-select @change="getchannelId" v-model="channelId" clearable placeholder="请选择">
        <el-option
          v-for="item in list"
          :key="item.id"
          :label="item.channel_name"
          :value="item.id">
        </el-option>
      </el-select>
      </el-form-item>
       <el-form-item label="设备名称">
        <el-input placeholder="请输入通道名称" v-model="branchName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="success" @click="search">查询</el-button>
        <el-button icon="el-icon-circle-plus-outline" type="primary" @click="add">新增</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="delList">删除</el-button>
        <el-button icon="el-icon-download" type="success" plain>导出</el-button>
        <el-button icon="el-icon-download" type="success" plain>规约特征配置</el-button>
        <el-button icon="el-icon-upload" type="success" plain>104快速导入</el-button>
        <el-button icon="el-icon-refresh" type="primary" ></el-button>
      </el-form-item>
    </el-form>
    <el-table :key="tableData" @selection-change="handleSelectionChange" :data="tableData" border style="width: 100%">
      <el-table-column
      type="selection"
      width="40">
    </el-table-column>
      <el-table-column prop="branchName" label="设备名称"></el-table-column>
      <el-table-column prop="channelId" label="所属通道">
         <template slot-scope="scope">
          <div v-for="(item, index) in list" :key="index">
            <span v-if="item.id === scope.row.channelId">{{item.channel_name}}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="createDate" label="设备描述"></el-table-column> -->
      <el-table-column prop="branchAddress" label="设备通讯地址"></el-table-column>
      <el-table-column prop="commonAddress" label="设备公共地址"></el-table-column>
      <el-table-column prop="compatiblePlatform" label="兼容平台"></el-table-column>
      <el-table-column prop="branchType" label="设备类型"></el-table-column>
      <el-table-column label="操作" style="height: 40px" width="250">
        <!-- <template slot-scope="scope"> -->
        <template slot-scope="scope">
          <el-button type="primary" @click="toOpen(scope.row)" size="small">查看</el-button>
          <el-button @click="handleClick(scope.row)" type="success" size="small">修改</el-button>
          <!-- <a class="target" style="color: #fff; text-decoration:none; padding: 5px 14px; border-radius: 5px; margin: 0 10px; display: inline-block; background: #67C23A;" href="" target="_blank">组态</a> -->
          <el-button type="danger" size="small" @click="delItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top:15px;"
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="query.page"
      :page-sizes="[10, 20, 30]"
      :page-size="query.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="query.total"
      background
    ></el-pagination>
    <el-dialog :close-on-click-modal="false" title="新增" width="800px" :visible.sync="dialogFormVisible">
  <el-form :model="form" status-icon>
    <el-form-item required label="所属通道" :label-width="formLabelWidth">
      <el-select @change="getchannelId1" v-model="form.channelId" clearable placeholder="请选择">
        <el-option
          v-for="item in list"
          :key="item.id"
          :label="item.channel_name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
     <el-form-item required label="设备名称" :label-width="formLabelWidth">
      <el-input v-model="form.branchName" placeholder="请输入" autocomplete="off"></el-input>
    </el-form-item>
     <el-form-item required label="设备通讯地址" :label-width="formLabelWidth">
      <el-input v-model="form.branchAddress" placeholder="请输入" autocomplete="off"></el-input>
    </el-form-item>
     <el-form-item required label="公共地址" :label-width="formLabelWidth">
      <el-input v-model="form.commonAddress" placeholder="请输入" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item required label="兼容平台" :label-width="formLabelWidth">
      <el-select @change="getcompatiblePlatform" v-model="form.compatiblePlatform" clearable placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
     <el-form-item required label="设备类型" :label-width="formLabelWidth">
      <el-input v-model="form.branchType" placeholder="请输入" autocomplete="off"></el-input>
    </el-form-item>
     <el-form-item required label="保留(0)" :label-width="formLabelWidth">
      <el-input v-model="form.item0" placeholder="请输入" autocomplete="off"></el-input>
    </el-form-item>
     <el-form-item required label="保留(1)" :label-width="formLabelWidth">
      <el-input v-model="form.item1" placeholder="请输入" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button v-show="show" type="primary" @click="submit">确 定</el-button>
    <el-button v-show="show1" type="primary" @click="update">修 改</el-button>

  </div>
</el-dialog>
  </div>
</template>

<script>
import {getSbList, addSbList, delSbList, updateSbItem, getTdAll} from '@/api/api.js'
export default {
  data() {
    return {
      show: true,
      show1: false,
      dialogFormVisible: false,
      query: {
        page: 1,
        size: 10,
        total: 0
      },
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      },
      value: '',
      activeName: 'first',
      formLabelWidth: '120px',
      form: {
        channelId: '',
        branchName: '',
        branchAddress: '',
        commonAddress: '',
        compatiblePlatform: '',
        branchType: '',
        gatewayId: '',
        item0: '',
        item1: '',
        channelType: '0'
      },
      options: [{
          value: 'wu',
          label: '无'
        }],
      channelId: '',
      branchName: '',
      tableData: [],
      list: [],
      ids: [],
      channelType: '0',
      gatewayId: window.localStorage.getItem('ids')
    };
  },
  activated() {
    getTdAll(this.channelType,this.gatewayId).then(res => {
      this.list = res.data.data
    })
  },
  components: {},
  created() {
    this.getList()
    
  },
  methods: {
    // 选择兼容
    getcompatiblePlatform(val) {
      this.form.compatiblePlatform = val
    },
    // 选择所属通道
    getchannelId1(val) {
      this.form.channelId = val
    },
    // 批量删除
    delList() {
      if (this.ids.length < 1) {
        this.$message({
          message: '请至少选择一条内容',
          type: 'warning'
        });
      }else {
        this.$confirm('是否删除这些内容?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delSbList(this.ids).then(res => {
            if(res.data.msg === 'success') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          this.getList()
          })
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      }
    },
    // 批量选中
    handleSelectionChange (val) {
      this.ids = []
      val.forEach(item => {
        this.ids.push(item.id)
      })
    },
    // 删除
    delItem(row) {
      this.ids = []
      this.ids.push(row.id)
      this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delSbList(this.ids).then(res => {
            if(res.data.msg === 'success') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          this.getList()
          })
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        })
    },
    // 选择通道名称
    getchannelId(val) {
      this.channelId = val
    },
    search() {
      this.getList()
    },
    // 获取列表
    getList () {
      getSbList(this.query.page, this.query.size, this.channelId, this.branchName,this.gatewayId,this.channelType).then(res => {
        if (res.data.msg === 'success') {
          this.tableData = res.data.data.list
          this.query.total = res.data.data.total
        } else {
          this.$message(res.data.msg)
        }
      })
    },
    toOpen (row) {
      this.dialogFormVisible = true
      this.form = row
    },
    pageChange(page) {
      this.query.page = page;
      this.getList()
    },
    sizeChange(size) {
      this.query.size = size;
    },
    // 修改
    update() {
      this.form.gatewayId = window.localStorage.getItem('ids')
      updateSbItem(this.form).then(res => {
        if(res.data.msg === 'success') {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.getList()
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          })
        }
      })
    },
    handleClick(row) {
      this.dialogFormVisible = true
      this.form = row
      this.show = false
      this.show1 = true
    },
    add () {
      this.form = {
        channelId: '',
        branchName: '',
        branchAddress: '',
        commonAddress: '',
        compatiblePlatform: '',
        branchType: '',
        gatewayId: '',
        item0: '',
        item1: '',
        channelType: '0'
      }
      this.show = true
      this.show1 = false
      this.dialogFormVisible = true
    },
    submit () {
       this.form.gatewayId = window.localStorage.getItem('ids')
      addSbList(this.form).then(res => {
        if (res.data.msg === 'success') {
          this.dialogFormVisible = false
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.form = {
             channelId: '',
              branchName: '',
              branchAddress: '',
              commonAddress: '',
              compatiblePlatform: '',
              branchType: '',
              gatewayId: '',
              item0: '',
              item1: '',
              channelType: '0'
          }
          this.getList()
        }
      })
      
    }
  }
};
</script>
<style lang="scss" scoped>
.el-form-item {
  display: inline-block;
}
</style>
